
$(function() {

    $(".co-triangle-toggle").click(function() { 
      if($(window).width() >= 768) {
        $('#header-tall-overlay').toggleClass("active");
        $('.co-triangle').toggleClass("active");
      } 
    });
    
    $(".close-overlay").click(function() { 
      $('#header-tall-overlay').removeClass("active");
      $('.co-triangle').removeClass("active"); 
    });

  });